module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Medium.594ad56d.ttf";